/**
 * Brake for the parent side of the demo authentication bridge.
 *
 * The iframe posts `authentication-required` whenever PHP answers "Invalid
 * token". For a genuinely expired customer JWT one refresh fixes it. But when
 * the rejection is structural (a stale persisted customer, a fingerprint that
 * no longer matches), re-minting produces the same rejection and the two
 * windows ping-pong until the demo session endpoint returns 429. Each token is
 * therefore refreshed at most ONCE, and a frame load gets a small total budget.
 */
interface IDemoAuthRetryGuard {
  /** True when the parent should mint a fresh session for this rejected token. */
  shouldRefresh: (rejectedToken: string | null) => boolean;
}

export function createDemoAuthRetryGuard(
  maxRefreshesPerLoad = 3
): IDemoAuthRetryGuard {
  const refreshedFor = new Set<string>();
  let refreshes = 0;
  return {
    shouldRefresh(rejectedToken) {
      const key = rejectedToken ?? '';
      if (refreshedFor.has(key) || refreshes >= maxRefreshesPerLoad)
        return false;
      refreshedFor.add(key);
      refreshes += 1;
      return true;
    },
  };
}
